import type { FunctionComponent } from 'react';
import { Card, Table, TableBody, TableCell, TableRow } from '@george-labs.com/design-system';

import { getTranslationFallbacks, normalizePath, useCurrentRoute } from '@luna/router';

import styles from './TitleTranslationCard.module.scss';
import { DevToolsCard } from '../DevToolsCard';

const TABLE_COLUMNS = [
    {
        id: 'translationKey',
        label: 'Translation key',
        width: '50%',
    },
    {
        id: 'translation',
        label: 'Translation',
        width: '50%',
    },
];

interface Props {
    defaultTitle: string;
}

export const TitleTranslationCard: FunctionComponent<Props> = ({ defaultTitle }) => {
    const currentRoute = useCurrentRoute();

    const translationFallbacks = getTranslationFallbacks(normalizePath(currentRoute), defaultTitle);

    let usedTranslationKey: string | undefined;
    const translationFallbacksWithColors = translationFallbacks.map(([key, translation]) => {
        if (key !== translation && !usedTranslationKey) {
            usedTranslationKey = key;
            return {
                key,
                translation,
                color: TableRow.DECORATION_COLOR.UI_GREEN,
            };
        }
        if (key !== translation) {
            return {
                key,
                translation,
                color: TableRow.DECORATION_COLOR.UI_BLUE_WEAK,
            };
        }
        return {
            key,
            translation,
            color: TableRow.DECORATION_COLOR.UI_RED_WEAK,
        };
    });

    return (
        <Card nested={false} className="mt-0 rounded-0">
            <DevToolsCard title="Title translation">
                <Table columns={TABLE_COLUMNS} className={styles.card}>
                    <TableBody>
                        {translationFallbacksWithColors.map(({ key, translation, color }) => (
                            <TableRow decorationColor={color} key={key} className={styles[color]}>
                                <TableCell>{key}</TableCell>
                                <TableCell>{translation}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DevToolsCard>
        </Card>
    );
};
